import { Outlet } from 'react-router-dom';

import { EmptyState, Icon, LinkButton } from '@/components/ui';
import { usePermissions } from '@/hooks/usePermissions';

import { paths } from './paths';

/**
 * Guards a page by permission, for a member who arrives by URL or bookmark
 * rather than through the navigation that already hides the link. The API
 * refuses the same requests; this only replaces a page of 403 errors with an
 * explanation. `permission` may be one code or a list, all of which are needed.
 */
export function RequirePermission({ permission, children }) {
  const { can } = usePermissions();
  const required = Array.isArray(permission) ? permission : [permission];

  if (!required.every((code) => can(code))) {
    return (
      <EmptyState
        icon={<Icon name="shieldCheck" size={22} />}
        title="You don't have access to this page"
        description="A workspace admin decides what each member can do. Ask them if you need this."
        action={
          <LinkButton to={paths.company.access} variant="secondary">
            See my access
          </LinkButton>
        }
      />
    );
  }

  return <>{children ?? <Outlet />}</>;
}
